import { render } from "./ClientDrivers.vue?vue&type=template&id=31528fad"
import script from "./ClientDrivers.vue?vue&type=script&lang=js"
export * from "./ClientDrivers.vue?vue&type=script&lang=js"

import "./ClientDrivers.vue?vue&type=style&index=0&id=31528fad&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__